module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.$t('customer.create')
    },
    model: {
      value: (_vm.customerDialog),
      callback: function($$v) {
        _vm.customerDialog = $$v
      },
      expression: "customerDialog"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "refCode",
      "label": _vm.$t('customer.refCode'),
      "rules": [{
        required: true,
        message: 'Please input reference code',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.refCode),
      callback: function($$v) {
        _vm.form.refCode = $$v
      },
      expression: "form.refCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "customerGroup",
      "label": _vm.$t('customer.type')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('customer.category')
    },
    model: {
      value: (_vm.form.customerGroup),
      callback: function($$v) {
        _vm.form.customerGroup = $$v
      },
      expression: "form.customerGroup"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('customer.name'),
      "rules": [{
        required: true,
        message: 'Please input customer\'s name',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phoneNumber",
      "label": _vm.$t('customer.phoneNumber'),
      "rules": [{
        type: 'string',
        min: 9,
        max: 10,
        message: 'Please input a valid phone number',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.phoneNumber),
      callback: function($$v) {
        _vm.form.phoneNumber = $$v
      },
      expression: "form.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('customer.email'),
      "rules": [{
        type: 'email',
        message: 'Please enter a valid email',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.customerDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.onSubmitClose(_vm.form)
      }
    }
  }, [_vm._v("Create and Close")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit(_vm.form)
      }
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-213e1d6a"}!./src/components/customer/create-dialog.html
// module id = 800
// module chunks = 1